import React from 'react';
import PropTypes from 'prop-types';

import SidebarContentContainer from '../../containers/SidebarContentContainer';

import styles from './Sidebar.module.scss';

const DesktopSidebar = React.memo(({ menuActived }) => {
  return (
    <aside
      className={`${menuActived ? styles.sidebar_full : styles.sidebar_mini} ${
        styles.sidebar_desktop
      }`}
    >
      <SidebarContentContainer />
    </aside>
  );
});

DesktopSidebar.propTypes = {
  menuActived: PropTypes.bool.isRequired,
};

export default DesktopSidebar;
